<template>
  <div :class="['form-section', { cglsModalClass: options && options.userCglsModalClass }]">
    <!-- 卡片标题 -->
    <h2 class="card-title" v-if="options && options.title">{{ options.title }}</h2>
    <slot name="head"></slot>
    <!-- 卡片部分 -->
    <div class="card">
      <div class="card-logo">
        <img v-if="myCardData.bankLogo" :src="myCardData.bankLogo" alt="bank logo" />
      </div>
      <div class="card-user">
        <p class="card-user-name">{{ myCardData.englishName }}</p>
        <p class="card-user-cardNum">{{ myCardData.dragoncode }}</p>
      </div>
      <div class="card-date">
        <p>{{ $t('dragoncard-vaild') }}</p>
        <p v-if="myCardData.cardValidDate">{{ myCardData.cardValidDate }}</p>
      </div>
    </div>
    <!-- 描述部分 -->
    <div class="desc">
      <p class="desc1">{{ $t('step4desc1') }}</p>
      <p class="desc2">{{ $t('step4desc2') }}</p>
      <p class="desc3" v-if="descShow">{{ $t('step4desc3') }}</p>
    </div>
    <!-- 按钮部分 -->
    <Button class="dpi-button dpi-button-primary" @click="goHome">{{ $t('homePage') }}</Button>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import store from '@/store';

  export default {
    props: {
      cardData: {
        type: Object,
        default: null,
      },
      options: {
        type: Object,
        default: () => {},
      },
    },

    data() {
      return {
        descShow: true,
      };
    },
    mounted() {
      this.descShow = this.options?.descShow ?? true;
    },
    computed: {
      myCardData() {
        return this.cardData?.dragoncode ? this.cardData : this.getcardData;
      },
      ...mapState(['getcardData']),
    },
    methods: {
      goHome() {
        this.$router.push('/');
      },
    },
    beforeUnmount() {
      sessionStorage.removeItem('ingenicoFailRegister');
      sessionStorage.removeItem('getcardData');
      store.commit('setState', {
        state: 'ingenicoFailRegister',
        values: false,
      });
      store.commit('setState', {
        state: 'getcardData',
        values: null,
      });
    },
  };
</script>

<style lang="scss" scoped>
  @use './index.scss';
  @use './mobile';
</style>
